// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__iymf6","checkboxCol":"Table_checkboxCol__A1e1J","emailCol":"Table_emailCol__1jjN1","actionCol":"Table_actionCol__1_wjr"};